import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Chart, registerables } from 'chart.js';
import { Account } from './shared/data/models/account.model';
import { CommonModule } from '@angular/common';
import { RaygunService } from './shared/data/raygun.service';

@Component({
    imports: [RouterModule, CommonModule],
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'WebApp';
  accountData: Account | null = null;

  constructor(private raygunService: RaygunService) {}

  ngOnInit(): void {
    Chart.register(...registerables);

    this.raygunService.initialize();
  }
}
